/* eslint-disable sonarjs/no-duplicate-string */
import { BaseForm } from 'app/pages/Registration/interfaces';

const json: BaseForm[] = [
  {
    path: 'email',
    content: [
      {
        type: 'email',
        label: 'email',
        required: true,
      },
    ],
  },
  {
    path: 'region',
    content: [
      {
        type: 'countrySelect',
        label: 'countrySelect',
        required: true,
      },
    ],
  },
  {
    path: 'companyDetails',
    content: [
      {
        type: 'string',
        label: 'companyName',
        required: true,
      },
      { type: 'string', label: 'addressLine1' },
      { type: 'string', label: 'addressLine2' },
      { type: 'string', label: 'postCode' },
      { type: 'string', label: 'regCode' },
      { type: 'string', label: 'vatNumber' },
    ],
  },
  {
    path: 'companyLocations',
    content: [
      {
        type: 'number',
        label: 'numberOfLocations',
        required: true,
        minimum: 1,
      },
    ],
  },
  {
    path: 'contactPerson',
    content: [
      { type: 'string', label: 'firstName', required: true },
      { type: 'string', label: 'lastName', required: true },
      { type: 'tel', label: 'phone', required: true },
      { type: 'string', label: 'role', required: true },
    ],
  },
  {
    path: 'password',
    content: [{ type: 'password', required: true, label: 'password' }],
  },
  {
    path: 'companySize',
    content: [
      {
        type: 'number',
        label: 'numberOfSystemUsers',
        required: true,
        minimum: 1,
      },
      {
        type: 'number',
        label: 'numberOfCashRegisters',
        required: true,
        minimum: 1,
      },
      {
        type: 'number',
        label: 'numberOfProducts',
        required: true,
        minimum: 1,
      },
    ],
  },
  {
    path: 'softwareQuestions',
    content: [
      { type: 'boolean', label: 'retailManagementSoftware' },
      { type: 'boolean', label: 'pointOfSale' },
      { type: 'boolean', label: 'warehouseManagement' },
      { type: 'boolean', label: 'stockTake' },
      { type: 'boolean', label: 'webshopConnection' },
    ],
  },
  {
    path: 'mobileHardwareQuestions',
    content: [
      {
        type: 'boolean',
        label: 'needsMobileHardware',
        options: [
          { type: 'boolean', label: 'androidTablet' },
          { type: 'boolean', label: 'iosTablet' },
          { type: 'boolean', label: 'starPortableBluetoothReceiptPrinter' },
          { type: 'boolean', label: 'starDesktopBluetoothReceiptPrinter' },
          { type: 'boolean', label: 'starDesktopNetworkLanReceiptPrinter' },
          { type: 'boolean', label: 'starDesktopNetworkWifiReceiptPrinter' },
          {
            type: 'boolean',
            label: 'starDesktopBluetoothPrinterCashDrawerMpop',
          },
          { type: 'boolean', label: 'desktopWiredCashDrawer' },
          { type: 'boolean', label: 'linearBluetoothBarcodeReader' },
          { type: 'boolean', label: 'twoDBluetoothBarcodeReader' },
          { type: 'boolean', label: 'hasNeededHardware' },
        ],
      },
    ],
  },
  {
    path: 'desktopHardwareQuestions',
    content: [
      {
        type: 'boolean',
        label: 'needsDesktopHardware',
        options: [
          { type: 'boolean', label: 'win10DesktopComputer' },
          {
            type: 'boolean',
            label: 'win10DesktopComputerWithIntegratedReceiptPrinter',
          },
          { type: 'boolean', label: 'usbReceiptPrinter' },
          { type: 'boolean', label: 'desktopNetworkLanReceiptPrinter' },
          { type: 'boolean', label: 'desktopNetworkWifiReceiptPrinter' },
          { type: 'boolean', label: 'desktopWiredCashDrawer' },
          { type: 'boolean', label: 'wiredLinearBarcodeReader' },
          { type: 'boolean', label: 'wiredUSB2DBarcodeReader' },
          { type: 'boolean', label: 'wireless2DBluetoothBarcodeReader' },
          { type: 'boolean', label: 'desktopScale' },
          { type: 'boolean', label: 'hasNeededHardware' },
        ],
      },
    ],
  },
  {
    path: 'pricePlan',
    content: [
      {
        type: 'pricePlan',
        label: 'pricePlan',
        required: true,
        options: [
          {
            title: 'pointOfSale',
            yearPrice: 19,
            monthPrice: 29,
            perks: [
              'Includes 2 User Accounts',
              '1 Point of Sale License',
              'Easy to Use Point of Sale',
              'Basic X- and Z-Report',
              'Basic CRM',
              'POS Mobile App',
              'Cayan Integrated Payments',
              'mPOS',
              'Email Receipts',
              'Flexible Hardware Support',
              'Bluetooth Peripheral Support',
              'Pop-up Shop Support',
              'Limited e-mail support only',
            ],
          },
          {
            title: 'inventoryForECommerce',
            yearPrice: 39,
            monthPrice: 59,
            perks: [
              'Includes 2 User Accounts',
              '1 Warehouse License',
              'Real-time Inventory Backend System',
              'Product Management',
              'Inventory Database',
              'Reporting',
              'Supplier Management',
              'Purchase and Receiving',
              'Packing Lists',
              'Barcode Labels',
              'Cycle Counts',
              'Multiple Product Types',
              'Kitting',
              'E-mail Purchase Orders',
              'Mobile Inventory',
              'Customizable Document Designer',
              'Shopify Integration',
              'E-commerce API',
              'Import/Export Tools',
            ],
          },
          {
            title: 'inventoryPlusRentalPos',
            yearPrice: 69,
            monthPrice: 79,
            perks: [
              'Includes 2 User Accounts',
              '1 POS with Inventory License',
              'Easy to Use Point of Sale',
              'mPOS',
              'Inventory Database',
              'Advanced Reporting',
              'Advanced Customer Database + API - 1M customers',
              'Purchase and Receiving',
              'Supplier Relationship Management',
              'Gift Cards, Store Credit System',
              'Promotions/Coupons and Marketing Intelligence',
              'Quotes/Sales Orders/Invoices',
              'Sales Commission Calculations',
              'Customizable Document Designer',
              'Wholesale',
              'House Accounts',
              'Customer Facing Display',
              'API Access',
              'WMS - Warehouse Management System Capability',
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'confirm',
    content: [{ type: 'confirm', label: 'confirm', required: true }],
  },
];

export default json;
